import striveMark from './assets/strive-mark.png';

import RemoteTabs from './Tab.js'

import './main.css'
import './f_style.css'

export default function RideEnded(props) {
    const uid = props.uid;
	const status = props.active;
	const name = props.driver_name;
    const passenger_id = props.passenger
    const paxProximity = props.pax_proximity
    const driverPaxProximity = props.driver_pax_proximity
    const pax_access = props.pax_access
    const driver_access = props.driver_access
    const start = props.start
    const og_idx = props.idx
    const alias = props.alias

    return (
        <div className='dark-container' style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ padding: '40px 24px', textAlign: 'center' }}>
                <img className='brand-logo' src={striveMark} alt='Strive.FM' width='48' height='48' style={{ width: '48px', height: '48px', margin: '0 auto 16px' }} />
                <h1 style={{ color: '#f0f0f2', fontSize: '20px', fontWeight: 600, margin: '0 0 8px' }}>
                    Thanks for Striving :)
                </h1>
                <p style={{ color: 'rgba(240,240,242,0.5)', fontSize: '14px', margin: '0 0 16px', lineHeight: 1.5 }}>
                    Still near the radio? Ask {(alias === "") ? "the driver" : alias} to disable Strive geo-fence lock from Strive app settings.
                </p>
            </div>

            <div style={{ width: '100%', flex: 1 }}>
                <RemoteTabs uid={uid} active={status} passenger={passenger_id} driver_pax_proximity={driverPaxProximity} pax_proximity={paxProximity} pax_access={pax_access} driver_access={driver_access} start={start} idx={og_idx}/>
            </div>

            <div className='remote_waves'>
                <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                    <defs>
                        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                    </defs>
                    <g className="parallax">
                        <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(108,114,255,0.15)" />
                        <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(108,114,255,0.10)" />
                        <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(108,114,255,0.05)" />
                        <use xlinkHref="#gentle-wave" x="48" y="7" fill="#0d0d0d" />
                    </g>
                </svg>
            </div>
            <p style={{ color: 'rgba(240,240,242,0.35)', fontSize: '12px', padding: '12px', textAlign: 'center' }}>
                Re-imagining radio @ Strive.FM
            </p>
        </div>
    )
}
